/* eslint-disable no-console */
import React from 'react';
import Alert from '@m4b-design/alert';
import { CSSTransition } from 'react-transition-group';
import { isUndefined, cs } from '../utils';
// 标签
/**
 * form 的默认校验处理结束的 errors 和 warning 的展示逻辑
 * 相对 arco form ，增加了 validateMessagesDisplayType 来增加message 的默认展示样式
 */
var FormItemTip = function (_a) {
    var _b;
    var validateMessagesDisplayType = _a.validateMessagesDisplayType, prefixCls = _a.prefixCls, help = _a.help, propsErrors = _a.errors, warnings = _a.warnings;
    var isAlert = validateMessagesDisplayType === 'alert';
    var isTooltip = validateMessagesDisplayType === 'tooltip';
    var errorTip = propsErrors.map(function (item, i) {
        if (item) {
            if (isAlert) {
                return (React.createElement("div", { key: i, role: "alert" },
                    React.createElement(Alert, { type: "error", background: true, content: item.message })));
            }
            return (React.createElement("div", { key: i, role: "alert" }, item.message));
        }
    });
    var warningTip = [];
    warnings.map(function (item, i) {
        warningTip.push(React.createElement("div", { key: i, role: "alert", className: "".concat(prefixCls, "-message-help-warning") }, item));
    });
    var isHelpTip = !isUndefined(help) || !!warningTip.length;
    var visible = isHelpTip || !!errorTip.length;
    return (visible && (React.createElement(CSSTransition, { in: visible, appear: true, classNames: "formblink", timeout: 300, unmountOnExit: true }, isTooltip ? (React.createElement("div", null)) : (React.createElement("div", { className: cs("".concat(prefixCls, "-message"), (_b = {},
            _b["".concat(prefixCls, "-message-help")] = isHelpTip,
            _b["".concat(prefixCls, "-message-alert")] = isAlert,
            _b)) }, !isUndefined(help) ? (help) : (React.createElement(React.Fragment, null,
        errorTip.length > 0 && errorTip,
        warningTip.length > 0 && warningTip)))))));
};
export default FormItemTip;
